import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { LogoDark } from "../components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    if (!sessionId) {
      window.location.replace("/login");
      return;
    }
    (async () => {
      try {
        const data = await loginWithGoogle(sessionId);
        window.location.replace(data.profile_complete ? "/student/dashboard" : "/enroll");
      } catch {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => window.location.replace("/login"), 2500);
      }
    })();
  }, [loginWithGoogle]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gradient-to-br from-violet-50 via-slate-50 to-indigo-50" data-testid="auth-callback">
      <LogoDark size={44} />
      {error ? (
        <p className="text-sm font-medium text-rose-600" data-testid="auth-callback-error">{error}</p>
      ) : (
        <>
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-indigo-200 border-t-indigo-600" />
          <p className="text-sm font-medium text-slate-600">Signing you in…</p>
        </>
      )}
    </div>
  );
}
